import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CustomCheckbox, CustomPanel, PageHeader } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import ModalOcorrencia from './ModalOcorrencia'
import useOcorrenciaPadraoEmpresa, { LOAD_MESSAGE } from './OcorrenciaPadraoEmpresaHook'

function OcorrenciaPadraoEmpresa({ dispatch, history }) {
  const { state, localDispatch } = useOcorrenciaPadraoEmpresa()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_REASONS:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMissingReasonStandard()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>S.27 - Ocorrências Padrões</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(state.selectedEmpresaID)}
          onVoltar={history.goBack}
        >
          <DataTable
            selectionMode="single"
            onSelectionChange={e => localDispatch.onRowClicked(e.value)}
            value={state.ocorrencias}
            paginator={true}
            rows={10}
            emptyMessage={'Nenhuma ocorrência encontrada'}
          >
            <Column field="sigla" header="Sigla" style={tableCellCentered()} />
            <Column field="descricao" header="Descrição" />
            <Column field="type" header="Tipo" style={tableCellCentered()} />
            <Column
              field="visible_picking"
              header="Etapa Separação"
              style={tableCellCentered()}
              body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.visible_picking} />}
            />
            <Column
              field="visible_delivery"
              header="Etapa Entrega"
              style={tableCellCentered()}
              body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.visible_delivery} />}
            />
            <Column
              field="devolucao_fisica"
              header="Devolução Física"
              style={tableCellCentered()}
              body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.devolucao_fisica} />}
            />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered()}
              body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.actived} />}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <ModalOcorrencia
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

export default connect()(withRouter(OcorrenciaPadraoEmpresa))
